/*eslint-disable*/
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, dateStyle, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../../components/AlertDialog";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';

export default function Observations({ Booking }) {
  const { api } = useContext(FirebaseContext);
  const { editUser, clearLoginError, updateBooking } = api;

  const location = useLocation();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const usersdata = useSelector((state) => state.usersdata);
  
  const booking = location.state.Booking
  const [data, setData] = useState([]);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  useEffect(() => {
    console.log("booking", booking);
    if (booking) {
      setData(Object.values(booking.observations));
    } else {
      setData([]);
    }
  }, [booking]);

  const columns = [
    {
      header: language.person_id,
      accessorKey: "person_id",
   
    },
    {
      header: "Date",
      accessorKey: "observation_date" ,type:"date",
     
    },
    {
      header: language.observation_datetime,
      accessorKey: "observation_datetime" , type :"time",
      
    },
    {
      header: language.observation_type_concept_id,
      accessorKey: "observation_type_concept_id",
   
    },
    {
      header: language.observation_source_concept_id,
      accessorKey: "observation_source_concept_id",
   
    },
    {
      header: language.provider_id,
      accessorKey: "provider_id",
   
    },
    {
      header: language.value_as_number,
      accessorKey: "value_as_number",
      
    },
    {
      header: language.value_as_string,
      accessorKey: "value_as_string",
  
    },
  ];
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  // const onRowAdd=(newData) =>{
  //   new Promise((resolve, reject) => {
  //     resolve();
  //     setTimeout(() => {
  //       let tempArr = data;
  //       tempArr.push(newData);
  //       setData([...tempArr]);
  //       dispatch(updateBooking({ ...booking, observations: tempArr }));
  //     }, 800);
  //   })
  // };

  
const onRowAdd = (newData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const tempArr = [...data];
      const newObservation = { ...newData, uuid: uuidv4() }; 
      tempArr.push(newObservation);
      setData(tempArr);
      dispatch(updateBooking({ ...booking, observations: tempArr }));
      resolve();
    }, 800);
  });
};

  
 

  // const  onRowUpdate= (newData) =>{
  //   new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve();
  //       let tempArr = data;
  //       const indexOf = data.indexOf(newData);

  //       console.log("newData", newData);

  //       if (indexOf > -1) {
  //         tempArr[indexOf] = newData;
  //         setNotes([...tempArr]);
  //         dispatch(
  //           updateBooking({ ...booking, observations: tempArr })
  //         );
  //         resolve();
  //       } else {
  //         setCommonAlert({
  //           open: true,
  //           msg: "No note found cant update",
  //         });
  //         resolve();
  //       }

  //       dispatch(editUser(newData.id, newData));
  //     }, 600);
  //   })
  // };


  const onRowUpdate = (newData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const tempArr = [...data];
      const index = tempArr.findIndex((item) => item.uuid === newData.uuid); // 👈 match by uuid

      if (index > -1) {
        tempArr[index] = newData;
        setData(tempArr);
        dispatch(updateBooking({ ...booking, observations: tempArr }));
      } else {
        setCommonAlert({
          open: true,
          msg: "No matching observation found, cannot update.",
        });
      }

      if (newData.id) {
        dispatch(editUser(newData.id, newData));
      }

      resolve();
    }, 600);
  });
};

  const   onRowDelete= (oldData) =>{
    new Promise((resolve) => {
      setTimeout(() => {
        let tempArr = data;
        const indexOf = data.indexOf(oldData);
        if (indexOf > -1) {
          tempArr.splice(indexOf, 1);
          setData([...tempArr]);
          dispatch(
            updateBooking({ ...booking, observations: tempArr })
          );
          resolve();
        } else {
          setCommonAlert({
            open: true,
            msg: "No note found cant delete",
          });
          resolve();
        }
      }, 600);
    })
  };


  return usersdata.loading ? (
    <CircularLoading />
  ) : (
    <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { person_id: false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>
  );
}
